"use strict";import{Toast as e}from"./src/Toast.js";import{defineElement as t}from"@spectrum-web-components/base/src/define-element.js";t("sp-toast",e);
//# sourceMappingURL=sp-toast.js.map
